import Controller from '@ember/controller';

export default class RequestChannelController extends Controller {
  hideConfirmationNote = false;
}
